<template>
	<div class="card" style="width: 1200px; margin: 0 auto">
		<el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px;position: relative;right:150px">

			<el-breadcrumb-item :to="{ path: '/' }"> <i class="el-icon-location"
					style="padding-right: 5px"></i>首页</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/other/'+article.moduleId }">{{ article.moduleName }}</el-breadcrumb-item>
			<el-breadcrumb-item>{{ article.title }}</el-breadcrumb-item>
		</el-breadcrumb>
		<h2 style="text-align: center;font-weight: bold;margin-top: 20px;margin-bottom: 20px">{{article.title}}</h2>
		<!--    <el-tag size="small">{{ article.moduleName }}</el-tag>-->
		<span style="color: gray"> 日期: {{article.createTime}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;来源: {{article.source}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-if="article.author != null">作者: {{article.author}}</span></span>
		<div style="width: 100%;height3px;border: 4px solid rgba(90,89,89,0.24);margin-bottom: 10px;margin-top: 10px">
		</div>
		<p style="font-size: 16px;
    font-family: '微软雅黑 Regular', 'Microsoft YaHei'!important;
    color: #333;" v-html="article.content" />
	</div>
</template>

<script>
	import {
		getMessage
	} from "../api";

	export default {
		name: 'showArticles',
		data() {
			return {
				article: {
					content: null,
					createTime: null,
					title: null,
				},
				id:this.$route.params.id
			}
		},
		created() {
			this.getMarquee();
		},
		watch: {
			$route() {
				this.id = this.$route.params.id
				this.getMarquee()
			},
		},
		mounted() {

		},
		updated() { //页面加载完毕事件
			window.scroll(0, 0);
		},
		methods: {
			getMarquee() {
				getMessage(this.$route.params.id).then(res => {
					this.article = res.data.data
					this.article.createTime = res.data.data.createTime.split(' ')[0];
				})
			},
		}
	}
</script>

<style scoped>
	.card {
		width: 80%;
		margin: auto;
	}
</style>
